var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff3B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.23 172.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232323;}.cls-2{fill:#f3b791;}.cls-3{fill:#7a6048;}.cls-4{fill:#1199a1;}.cls-5{fill:#0e5279;}.cls-6{fill:#004568;}.cls-7{fill:#14adb2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering",
    "data-name": "Formulering & Stabilisering"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.86,165.17s-2,4.72-.57,6.18,3.11,2.52,9.84-.43,12.51-7.76,10.18-9.08-8.17-.75-12.56,1.07A37.26,37.26,0,0,1,28.86,165.17Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.9,151.18s-.44,4.88-.66,6.43,1.91,4.47,8.42.89c4.44-2.44,7.49-3.74,10.2-5.77s.22-4.43-3.1-4S5.9,151.18,5.9,151.18Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.49,32.15l.22-6c-5.32-2.88-11.31-10-7.54-17.51S20.26,1.33,24,2.22s9.09,3.32,9.31,8.86,0,12.42-.89,14-5.32,2.22-5.32,2.22c-.22,2-.44,6.21-.44,6.21Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.59,0a13.79,13.79,0,0,0-6.87,2A6.2,6.2,0,1,0,5.87,12.34a11.4,11.4,0,0,0,0,1.85c.44,6.21,7.31,12.41,10.86,12s6.87-1.77,6.65-3.77c-1.33.22-3-.94-3.32-4.1s3.49-5.07,4.87-2.33c0,0,9.76-3.1,8.43-10C30.45,2.66,26.24,0,19.59,0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.83,28.33c-2.84-1.83-6.27.09-8,2.66S1.42,39,.41,46.73c-.66,5.1-.68,11.07,1.11,12.86s6.21,2.66,10.64.66S15.93,30.32,12.83,28.33Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26.08,125.47c.22,10.19,1.11,32.58,1.11,39.24S39.29,168,39.6,161.6c.44-9.31.67-39.68.67-39.68Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19,122.8c-.88,14.64-2,23.73-2.44,28.16s-12.41,6.21-12.19,0c.3-8.43,2-35,2-35Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.38,61l8.42-3.1A36.47,36.47,0,0,1,53.35,53c2.21-1.33,4-2.22,4.87-1.77S55.34,55,55.34,55a74.94,74.94,0,0,1,7.76-2,2.66,2.66,0,0,1,1.11,2.44C64,57,61.77,60.29,61.77,60.29l-6.21,2.88-6.2.44-8.65,4.21Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M18.24,28.7c7.43,1.65,14,3,15.82,7.64s3.1,31.71,4,37.47,3.77,14.41,4.88,25.94,2,23.5,2,23.5c-4.43,4.88-14.85,5.32-20,5.1s-16.63-.89-21.73-7.1c.45-8.42,1.11-25,1.78-35s2.55-17.38,1.1-27.49C5,51,4.57,44.33,5.68,37.9,6.67,32.18,7.7,26.36,18.24,28.7Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.18,33.24c4.35-.87,7.09,5.76,7.76,13.08s1.1,12,1.1,12,4.88-.22,7.76-.44,5.51,5.71,1.78,8.2c-3.33,2.22-10.87,5.32-14.19,3.77S27.63,57,26.3,50.09,24.53,34.57,31.18,33.24Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff3B);
export default __webpack_public_path__ + "static/media/staff-3-b.e13c836020f2d5f2dc0940bfd817b902.svg";
export { ForwardRef as ReactComponent };